<script>
import resources from './resources'

export default {
  name: 'professional-specialitions-form',
  mixins: [resources],
  data () {
    return {
      show: true,
      beenUpdated: false,
      wasRaised: false
    }
  }
}
</script>

<template lang="pug">
page(title="Minhas Especializações", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        .nav-tabs-wrapper
          ul.nav.nav-tabs.nav-340
            li
              router-link(:to="{name: 'professional.curriculum.specializations.index' }")
               a(href='#') Listagem
            li.active
              a(href='#') Cadastro
        .col-xs-12.white-bg
          .row
            .col-xs-12
              form.col-sm-10
                label(style='margin-top:30px;') Profissional
                br
                h4
                  label(for='profissional') {{ professional.name }} (CRM — {{ professional.document }}/{{ professional.state }})
                .form-group
                  .row
                    .col-xs-12.col-sm-7.margin-bottom
                      v-input(:status="$v.specialization.type_specialization_id.$error ? 'error' : null")
                        f-select-type-specialization(
                          label="Tipo",
                          name="type_specialization_id",
                          v-model="specialization.type_specialization_id",
                          :get-all="true",
                          :searchable="true",
                          :errors="errors['type_specialization_id']",
                          @selected="setTypeSpecialization")

                    .col-xs-12.col-sm-5.margin-bottom
                      v-input(:status="$v.specialization.speciality_id.$error ? 'error' : null")
                        f-select-speciality(
                          label="Especialidade Relacionada",
                          name="speciality_id",
                          v-model="specialization.speciality_id",
                          :get-all="true",
                          :searchable="true",
                          :errors="errors['speciality_id']")

                .form-group
                  .row
                    .col-xs-12.col-sm-9.margin-bottom
                      f-text(
                        label="Nome do Curso",
                        name="area",
                        :disabled="isTitleOfSpecialization",
                        v-model="specialization.area",
                        :errors="errors['area']")

                    .col-xs-12.col-sm-3.margin-bottom
                      label Data de Emissão
                      v-datepicker(
                        v-model="specialization.issuance_date",
                        name="issuance_date",
                        :config='config')

                .form-group
                  .row
                    .col-xs-12.col-sm-6.margin-bottom
                      v-input(:status="$v.specialization.entity_name.$error ? 'error' : null")
                        f-text(
                          label="Entidade de Ensino",
                          name="entity_name",
                          v-model="specialization.entity_name",
                          :errors="errors['entity_name']")

                    .col-xs-12.col-sm-3.margin-bottom
                      label Início
                      v-picker-months(
                        v-model="specialization.start",
                        name="start",
                        :disabled="isTitleOfSpecialization",
                        placeholder="mm/aaaa",
                        :configMonths='configMonths')

                    .col-xs-12.col-sm-3.margin-bottom
                      label Final
                      v-picker-months(
                        v-model="specialization.end",
                        name="end",
                        :disabled="isTitleOfSpecialization",
                        placeholder="mm/aaaa",
                        :configMonths='configMonths')

                  //-- Removido provisorio para no format de upload
                  //--.row
                    .col-xs-12.col-md-12
                      f-file-text(
                        v-if="!specialization.attachment.uuid",
                        label="Anexar comprovante"
                        v-model="specialization.attachment",
                        name='attachment',
                        :errors="errors['attachment'] || errors['attachment.file'] || errors['attachment.mime']")

                .buttons-wrapper
                  button.btn.save(@click.prevent="doSave()")
                    span.icon 
                    |  Salvar Alterações
</template>



// WEBPACK FOOTER //
// src/app/professional/curriculum/specializations/form/form.vue